export { default } from "-!./Logs.ts?vue&type=script&lang=ts&external"; export * from "-!./Logs.ts?vue&type=script&lang=ts&external"